module.exports = __webpack_public_path__ + "img/pauli-line-long.c73b39fc.svg";